<table class="appointments-table">
    <thead>
        <tr>
            <th><span translate>COMPLAINT_APPOINTMENT|Nr wizyty</span></th>
            <th *ngIf="viewComplaintOrderNumber"><span style="cursor: default" translate>COMPLAINT_APPOINTMENT|Nr zamówienia pierwotnego</span></th>
            <th><span translate>COMPLAINT_APPOINTMENT|Klient</span></th>
            <th *ngIf="viewAssignedDistributor"><span translate>COMPLAINT|Przypisany dystrybutor</span></th>
            <th *ngIf="viewAssignedAuthorizedRetailer"><span translate>COMPLAINT|Przypisany APS</span></th>
            <th><span (click)="orderBy('date')" class="order-column">{{ 'COMPLAINT_APPOINTMENT|Planowana data wizyty' | translate }}<icc-sort-order-icon [sort]="columnSortOptions['date']"></icc-sort-order-icon></span></th>
            <th><span translate>COMPLAINT_APPOINTMENT|Przypisanie</span></th>
            <th><span translate>COMPLAINT_APPOINTMENT|Pracownik</span></th>
            <th>
                <span translate>COMPLAINT_APPOINTMENT|Planowany czas</span>
                <span translate>COMPLAINT_APPOINTMENT|Wykorzystany czas</span>
            </th>
            <th><span translate>COMPLAINT_APPOINTMENT|Status</span></th>
            <th translate>INTERFACE|Opcje</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let appointment of orderedAppointments | paginate: { itemsPerPage: appointmentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
            <ng-container *ngTemplateOutlet="appointmentRow; context: { appointment: appointment, node: appointment }"></ng-container>
        </ng-container>
    </tbody>
</table>
<pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
></pagination-controls>

<ng-template #appointmentRow let-document="document" let-appointment="appointment" let-node="node">
    <tr [class.appointments-table__row--message]="node.message">
        <td class="appointments-table__name" (click)="open(appointment.documentId, appointment.uuid)">
            <span *ngIf="appointment?.documentNumber">
                {{ appointment?.documentNumber?.join ? appointment?.documentNumber.join('') : '' }} #{{ appointment?.internalIndex }}
            </span>
        </td>
        <td *ngIf="viewComplaintOrderNumber" class="appointments-table__name" (click)="open(appointment.documentId, appointment.uuid)">
            <ng-container *ngIf="getUniqueDistributorOrderNumbers(appointment).length > 0">
                <span *ngFor="let distributorOrderNumber of getUniqueDistributorOrderNumbers(appointment)">
                    {{ distributorOrderNumber }}
                </span>
            </ng-container>
        </td>
        <td class="appointments-table__client" (click)="open(appointment.documentId, appointment.uuid)">
            <span class="appointments-table__client-name" *ngIf="appointment?.clientName" >
                {{ appointment?.clientName }}
            <br>
            </span>
            <span class="appointments-table__client-address" *ngIf="appointment?.installationAddress" >
                {{ appointment?.installationAddress }}
            <br>
            </span>
            <a
                *ngIf="appointment.locationSource === 'manual' || appointment.locationDescription || appointment.locationPartialMatchConfirmed"
                class="appointments-table__location-link"
                (click)="openLocationDialog(appointment); $event.stopPropagation()"
            >
                {{ 'COMPLAINT|Lokalizacja' | translate }}
            </a>
        </td>
        <td *ngIf="viewAssignedDistributor" class="appointments-table__assigned-distributor" (click)="open(appointment.documentId, appointment.uuid)">
            {{ getAssignedDistributor(appointment) }}
        </td>
        <td *ngIf="viewAssignedAuthorizedRetailer" class="appointments-table__assigned-distributor" (click)="open(appointment.documentId, appointment.uuid)">
            {{ getAssignedAuthorizedRetailer(appointment) }}
        </td>
        <td class="appointments-table__date" (click)="open(appointment.documentId, appointment.uuid)">
            {{ appointment?.date | date: 'shortDate' }} {{ appointment.time ? ('COMPLAINT_APPOINTMENT|godz. {time}' | translate : { time: appointment?.time }) : '' }}
        </td>
        <td class="appointments-table__assigned-to" (click)="open(appointment.documentId, appointment.uuid)">
            {{ appointment?.companyName ? appointment?.companyName : ('INTERFACE|Brak' | translate) }}
        </td>
        <td class="appointments-table__responsible-worker" (click)="open(appointment.documentId, appointment.uuid)">
            {{ appointment?.assignedUserId ? getWorkerName(appointment.assignedUserId) : ('INTERFACE|Brak' | translate) }}
        </td>
        <td class="appointments-table__time" (click)="open(appointment.documentId, appointment.uuid)">
            {{ appointment?.scheduledTime ? (appointment?.scheduledTime + ' min') : ('INTERFACE|Brak' | translate) }}<br>
            {{ appointment?.timeUsed ? (appointment?.timeUsed + ' min') : ('INTERFACE|Brak' | translate) }}
        </td>
        <td class="appointments-table__status" (click)="open(appointment.documentId, appointment.uuid)">
            <span *ngIf="appointment.status" class="appointment-card__status">
                <icc-appointment-status [status]="appointment.status"></icc-appointment-status>
            </span>
        </td>
        <td>
            <div class="appointments-table__options">
                <button iccButton appearance="secondary" (click)="open(appointment.documentId, appointment.uuid)">
                    {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                </button>
            </div>
        </td>
    </tr>
</ng-template>
